import './array'



// WEBPACK FOOTER //
// ./src/common/js/polyfill/index.js